export const DEFAULT_DELIVERY_TIME = 20;
